/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerGetTransferQueryResponse, TransfersControllerGetTransferPathParams, TransfersControllerGetTransferQueryParams, TransfersControllerGetTransfer400, TransfersControllerGetTransfer401, TransfersControllerGetTransfer403, TransfersControllerGetTransfer404 } from "../../models/transfersController/TransfersControllerGetTransfer";

function getTransfersControllerGetTransferUrl(id: TransfersControllerGetTransferPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/transfers/${id}` as const }  
  return res
}

/**
 * @summary Get transfer run details
 * {@link /api/v1/transfers/:id}
 */
export async function transfersControllerGetTransfer(id: TransfersControllerGetTransferPathParams["id"], params?: TransfersControllerGetTransferQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransfersControllerGetTransferQueryResponse, ResponseErrorConfig<TransfersControllerGetTransfer400 | TransfersControllerGetTransfer401 | TransfersControllerGetTransfer403 | TransfersControllerGetTransfer404>, unknown>({ method : "GET", url : getTransfersControllerGetTransferUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}